/**
 * JavaScript developed and modified by Souleymane Dembele on 1/22/2020
 */

import "isomorphic-fetch";

function makeFetch(url, info) {
  return fetch(url, info);
}

async function json(url, method = "GET", payload = {}) {
  // const jwtToken = await getSessionToken();
  let data = {
    method,
    mode: "cors",
    body: JSON.stringify(payload),
    headers: new Headers({
      "Content-Type": "application/json",
    }),
  };

  if (method === "GET") {
    delete data.body;
  }

  let response = await makeFetch(url, data);

  if (response.ok) {
    let contentType = response.headers.get("Content-Type");

    if (contentType?.indexOf("application/json") > -1) {
      return response.json();
    }

    return response.statusText;
  }
  throw response;
}

// application/json only
function get(url) {
  return json(url);
}

function post(url, payload) {
  return json(url, "POST", payload);
}

function put(url, payload) {
  return json(url, "PUT", payload);
}

function destroy(url, payload) {
  return json(url, "DELETE", payload);
}
// File readed
function reader(file) {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.onload = () => resolve(fileReader.result);
    fileReader.readAsDataURL(file);
  });
}

export { get, post, put, destroy, makeFetch, reader };
